/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

'use strict';

import * as angular from 'angular';
import { environment } from 'src/environments/environment-variables';

angular
	.module('ticketspaceApp.dev-settings', [])

	.constant('firebaseRefUrl', environment.refUrl)
	.constant('developerMode', environment.developerMode)
	.constant('defaultUserTier', environment.defaultUserTier)
	.value('git', []);
